import React, { useState, useEffect } from "react";
import axios from "axios";
import DataCollection from "./data-collection/data-collection";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";

const Vuelos = () => {
  // Variables de estado
  const [show_form_flights, set_show_form_flights] = useState(true);
  const [flightNumber, setFlightNumber] = useState("");
  const [year, setYear] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  const [flightData, setFlightData] = useState(null);

  // Funciones
  const handleToggleFormFlights = () => {
    set_show_form_flights((prevState) => !prevState);
  };

  const handleInputChange = (e) => {
    setFlightNumber(e.target.value);
  };

  const handleSelectChange = (e) => {
    setYear(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/flights/findOne`,
        {
          flight_number: flightNumber,
          year: year,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      const data = response.data;
      if (data) {
        setFlightData(data);
        set_show_form_flights(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Vuelo no valido",
          text: "El vuelo ingresado no existe.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Vuelo no disponible",
        text: "No se encontró información del vuelo ingresado.",
      });
    }
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const years = [nextYear, currentYear];

    // Añadir años anteriores hasta 2022
    for (let y = currentYear - 1; y >= 2022; y--) {
      years.push(y);
    }

    setYearsOptions(years);
    setYear(currentYear.toString()); // Establecer el año actual como valor predeterminado
  }, []);

  // Vistas
  const view_form_flights = (
    <>
      <ScrollToTop />
      <div className="container d-flex justify-content-center">
        <div className="row">
          <div className="col-12 col-md-6 mt-3 form-group">
            <label className="bolder mb-2" htmlFor="awb">
              <b>Ingrese número de vuelo</b>
            </label>
            <input
              id="awb"
              className="form-control"
              type="text"
              name="awb"
              value={flightNumber}
              onChange={handleInputChange}
            ></input>
          </div>

          <div className="col-12 col-md-6 mt-3 form-group">
            <label className="bolder mb-2" htmlFor="awb">
              <b>Seleccione año</b>
            </label>
            <select
              className="form-select"
              aria-label="Disabled select example"
              value={year}
              onChange={handleSelectChange}
            >
              {yearsOptions.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group col-12 mt-3">
            <div className="ms-auto text-end">
              <button
                type="button"
                className="btn btn-primary custom-background"
                onClick={handleSubmit}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  // Vista final
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="container awb-container">
          {show_form_flights ? (
            view_form_flights
          ) : (
            <DataCollection
              flightData={flightData}
              handleToggleFormFlights={handleToggleFormFlights}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Vuelos;
